<img
  ngSrc="assets/images/svg/logo.svg"
  width="93"
  height="45"
  alt="logo"
  priority
  style="object-fit: contain"
/>
